export default __webpack_public_path__ + "static/media/leader_notes.a581d765.pdf";